export enum QueryType {
  journeyDemand = 1,
  driverDemand = 2,
  sectorizedDemand = 3
}

export enum JourneyDemandTab {
  graph = 'graph',
  table = 'table'
}

export enum FormatDate {
  MONTHLY = 'MMM YYYY',
  DAILY = 'ddd DD-MMM-YYYY',
  YEARLY = 'YYYY',
  HOURLY = 'DD-MMM-YYYY hh:mm A'
}

export enum ColorChartEnum {
  purple = 0,
  blue = 1
}

export enum ColorElderChartEnum {
  yellow = 0,
  orange = 1
}
